import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = { class: "relative inline-block text-left" }
const _hoisted_3 = { class: "pb-3 space-x-3" }
const _hoisted_4 = { class: "relative z-0 flex-1 gap-2 overflow-y-auto focus:outline-hidden xl:order-last bg-gray-50" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = { class: "h-full border rounded-lg" }
const _hoisted_7 = { class: "px-6 py-2 sm:py-4 md:p-8" }
const _hoisted_8 = { class: "learningModuleTab md:h-full" }
const _hoisted_9 = { class: "w-full my-6" }
const _hoisted_10 = {
  key: 0,
  role: "list",
  class: "grid grid-cols-1 gap-5 mt-3 sm:gap-6 sm:grid-cols-2 lg:grid-cols-4"
}
const _hoisted_11 = { class: "flex items-center justify-center w-16 text-sm font-medium text-white bg-white shrink-0 rounded-l-md" }
const _hoisted_12 = ["href"]
const _hoisted_13 = ["alt", "src"]
const _hoisted_14 = { class: "flex items-center justify-between flex-1 truncate bg-white border-t border-b border-r border-gray-200 rounded-r-md" }
const _hoisted_15 = { class: "flex-1 px-4 py-2 text-sm truncate" }
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "text-gray-600 truncate" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = {
  key: 2,
  role: "list",
  class: "grid grid-cols-1 gap-5 mt-3 sm:gap-6 sm:grid-cols-2 lg:grid-cols-4"
}

import { computed, onMounted, Ref, ref } from "vue";
import { client } from "@/shared";
// @ts-ignore
import SaCombobox from "@/main/components/SaCombobox.vue";
import { GetBookmarks, GetBookmarksResponse, YourBookmarkDto } from "@/dtos";
import SaSelect from "@/main/components/SaSelect.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'YourBookmarks',
  setup(__props) {

// @ts-ignore
let responseStatus = ref(null);
let bookmarks: Ref<YourBookmarkDto[]> = ref([]);

const filterOptions = [
  { name: "All", value: "All" },
  { name: "Auditions & Jobs", value: "Auditions & Jobs" },
  { name: "Blog Posts", value: "Blogs" },
  { name: "Characters", value: "Characters" },
  { name: "College Programs", value: "College Programs" },
  { name: "Learning Modules", value: "Learning Modules" },
  { name: "Monologues", value: "Monologues" },
  { name: "Playwrights & Composers", value: "Writers" },
  { name: "Scenes", value: "Scenes" },
  { name: "Shows", value: "Shows" },
  { name: "Songs", value: "Songs" },
  { name: "Talent", value: "Talent" },
  { name: "Theatre Companies", value: "Companies" }
];
let selectedFilter = ref({ name: "All", value: "All" });
let bookmarksLoaded: Ref<Boolean> = ref(false);

onMounted(async () => {
  await getBookmarks();
});

const getBookmarks = async () => {
  bookmarksLoaded.value = false;
  await client.get<GetBookmarksResponse>(new GetBookmarks()).then(response => {
    bookmarksLoaded.value = true;

    bookmarks.value = response.bookmarks;
  });
};

let filteredBookmarks = computed(() =>
  selectedFilter.value.name === "All"
    ? bookmarks.value
    : bookmarks.value.filter((bookmark: YourBookmarkDto) => {
        return bookmark.type.includes(selectedFilter.value.name);
      })
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[1] || (_cache[1] = _createElementVNode("h3", { class: "inline-flex font-semibold" }, "Viewing", -1)),
          _createVNode(SaSelect, {
            id: "filter",
            name: "filter",
            modelValue: _unref(selectedFilter),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedFilter) ? (selectedFilter).value = $event : selectedFilter = $event)),
            options: filterOptions
          }, {
            option: _withCtx(({ option }) => [
              _createTextVNode(_toDisplayString(option.name), 1)
            ]),
            selected: _withCtx(({ option }) => [
              _createTextVNode(_toDisplayString(option.name ?? "Select an option"), 1)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                (_unref(bookmarksLoaded) && _unref(filteredBookmarks).length > 0)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredBookmarks), (bookmark) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: bookmark.id,
                          class: "flex col-span-1 rounded-md shadow-sm"
                        }, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("a", {
                              href: bookmark.targetUrl
                            }, [
                              _createElementVNode("img", {
                                alt: bookmark.title,
                                src: bookmark.imageUrl
                              }, null, 8, _hoisted_13)
                            ], 8, _hoisted_12)
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("a", {
                                href: bookmark.targetUrl,
                                class: "font-medium text-gray-900 hover:text-gray-600"
                              }, _toDisplayString(bookmark.title), 9, _hoisted_16),
                              _createElementVNode("p", _hoisted_17, _toDisplayString(bookmark.subtitle), 1)
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (_unref(bookmarksLoaded) && _unref(filteredBookmarks).length < 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, _cache[2] || (_cache[2] = [
                        _createElementVNode("div", { class: "text-center" }, [
                          _createElementVNode("h2", { class: "mt-2 text-base font-semibold leading-6 text-gray-600" }, " You have not bookmarked any content yet. ")
                        ], -1)
                      ])))
                    : (_openBlock(), _createElementBlock("ul", _hoisted_19, _cache[3] || (_cache[3] = [
                        _createElementVNode("li", {
                          role: "status",
                          class: "text-center shadow-sm animate-pulse"
                        }, [
                          _createElementVNode("div", { class: "relative flex items-center space-x-3 bg-white border border-clay-500 shadow-sm focus-within:ring-2 focus-within:ring-electric-500 focus-within:ring-offset-2 hover:border-gray-400" }, [
                            _createElementVNode("div", { class: "shrink-0" }, [
                              _createElementVNode("div", { class: "flex items-center justify-center mx-auto bg-gray-300 w-14 h-14 dark:bg-gray-700" }, [
                                _createElementVNode("svg", {
                                  class: "w-6 h-6 text-gray-200 dark:text-gray-600",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  "aria-hidden": "true",
                                  fill: "currentColor",
                                  viewBox: "0 0 640 512"
                                }, [
                                  _createElementVNode("path", { d: "M480 80C480 35.82 515.8 0 560 0C604.2 0 640 35.82 640 80C640 124.2 604.2 160 560 160C515.8 160 480 124.2 480 80zM0 456.1C0 445.6 2.964 435.3 8.551 426.4L225.3 81.01C231.9 70.42 243.5 64 256 64C268.5 64 280.1 70.42 286.8 81.01L412.7 281.7L460.9 202.7C464.1 196.1 472.2 192 480 192C487.8 192 495 196.1 499.1 202.7L631.1 419.1C636.9 428.6 640 439.7 640 450.9C640 484.6 612.6 512 578.9 512H55.91C25.03 512 .0006 486.1 .0006 456.1L0 456.1z" })
                                ])
                              ])
                            ]),
                            _createElementVNode("div", { class: "flex-1 min-w-0" }, [
                              _createElementVNode("div", { class: "w-24 h-2 mb-4 bg-gray-200 rounded-full dark:bg-gray-700" }),
                              _createElementVNode("div", { class: "w-32 h-2 bg-gray-200 rounded-full dark:bg-gray-700" })
                            ])
                          ])
                        ], -1)
                      ])))
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})